import { render } from "./PrefComp.vue?vue&type=template&id=b1b75d32&scoped=true"
import script from "./PrefComp.vue?vue&type=script&lang=js"
export * from "./PrefComp.vue?vue&type=script&lang=js"

import "./PrefComp.vue?vue&type=style&index=0&id=b1b75d32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b75d32"]])

export default __exports__